export const baseWidgetUrl = 'https://buy.ramp.network/';
